import React from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { forwardTo } from '../../helpers';
import { ContentSearcher } from './../ContentSearcher/ContentSearcher';
import './header.css';
/* ICONS */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTree, faBook, faSignOutAlt, faUser, faSeedling } from '@fortawesome/free-solid-svg-icons'
/* ICONS */
import { useTranslation } from 'react-i18next';
import { incidentsActions } from './../../actions/incidents.actions';

export const Header_430e = props => {
  const { users, dispatch } = props;
  const { t } = useTranslation();

  const logOut = () => {
    dispatch(incidentsActions.clearIncidents());
    forwardTo('/login')
  }

  return (
    <div id="header">
      <Navbar className="alco-men fixed-top" expand="lg" collapseOnSelect>
        <Navbar.Toggle className="buttomToggle" aria-controls="basic-navbar-nav" id="buttonToggle"></Navbar.Toggle>
        {/*<div className="nav-title">
          <span className="concejalia-name">Concejalía de Sostenibilidad, Movilidad y Renovables</span>
          <span>Ayuntamiento de Alcorcón</span>
  </div>*/}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link disabled >Ayuntamiento de Alcorcón | Concejalía de Sostenibilidad, Movilidad y Renovables</Nav.Link>
          </Nav>
          <Nav className="alco-men" >
            <Nav.Link onClick={() => forwardTo('/alcorcon/Sostenibilidad-Movilidad-Renovables')}><FontAwesomeIcon icon={faSeedling} />{t("nav.nav1")}</Nav.Link>
            <NavDropdown title="Consultas e Incidencias" id="nav-dropdown">
              <NavDropdown.Item onClick={() => forwardTo('/alcorcon/contacto-medioambiente')}>Consulta</NavDropdown.Item>
              <Nav className="menu2" >
                {!users.loggedIn ?
                  <NavDropdown.Item onClick={() => forwardTo('/login', '?ao=430')}>Incidencias</NavDropdown.Item>
                  :
                  <NavDropdown className="expadir-menu" title={<><FontAwesomeIcon icon={faUser} />{t("nav.nav6")}</>} id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={() => forwardTo('/new-incident')}>{t("nav.nav6-1")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => forwardTo('/incidents')}>{t("nav.nav6-2")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => forwardTo('/nearby')}>{t("nav.nav6-3")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => forwardTo('/settings')}>{t("nav.nav6-4")}</NavDropdown.Item>
                    <NavDropdown.Item onClick={logOut}><FontAwesomeIcon icon={faSignOutAlt} />{t("nav.nav6-5")}</NavDropdown.Item>
                  </NavDropdown>
                }
              </Nav>
            </NavDropdown>
            <Nav.Link onClick={() => forwardTo('/alcorcon/contenido-relacionado')}><FontAwesomeIcon icon={faBook} />Contenido de interés</Nav.Link>
            <ContentSearcher />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div >
  );
}
export default Header_430e;